export default {
  commodity_management: ['commodity_management'],
  commodity_add: ['commodity_add'],
  commodity_edit: ['commodity_edit'],
  commodity_status: ['commodity_edit'],
  commodity_delete: ['commodity_delete'],
  commodity_history_management: ['commodity_history_management']
}
